export default "__VITE_ASSET__BijYkDwM__"